import { AuditMatch } from '@mi-front/core';

/**
 * Keeps matches whose linked schedule order/version equal the given filters.
 * Empty filters are ignored.
 */
export function filterSpotMatchesByScheduleMeta(
  matches: AuditMatch[],
  filters: { order?: string; version?: string },
): AuditMatch[] {
  const order = filters.order?.trim();
  const version = filters.version?.trim();

  if (!order && !version) {
    return matches;
  }

  return matches.filter((match) => {
    if (order && match.matchedSchedule?.order !== order) {
      return false;
    }

    if (version && match.matchedSchedule?.version !== version) {
      return false;
    }

    return true;
  });
}
